import DescriptionIcon from "@mui/icons-material/Description";
import permissions from "app/permissions";
import { GRADUATED_STUDENT_DOCUMENTS, GraduationServicePath } from "utils/constants";
import { tenants } from "utils/tenants";
import GraduatedStudentDocuments from "./GraduatedStudentDocuments";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <DescriptionIcon />,
  name: GraduationServicePath + GRADUATED_STUDENT_DOCUMENTS,
  title: "Документи за дипломирани студенти",
  custom: <GraduatedStudentDocuments />,
  permission: permissions.canGenerateAcademicRequestDocuments,
};
